import React, { useState } from "react";
import { connect } from "react-redux";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";

import { SNOOP_NUMBER, BARGE_NUMBER, WHISPER_NUMBER } from "../../../../config";

const Callers = props => {
  const initialState = () => {
    return {
      playing: false,
      key: "",
      buttonName: "",
    };
  };

  const [playingStatus, setPlayingStatus] = useState(initialState);

  const testCall = (dest, key, buttonName, headerContent) => {
    // props.startCall("104");
    // console.log("Start Call");
    if (playingStatus.playing) {
      if (
        playingStatus.key === key &&
        playingStatus.buttonName === buttonName
      ) {
        props.stopCall();
        setPlayingStatus({
          playing: false,
          key: "",
          buttonName: "",
        });
      } else {
        props.stopCall();
        props.startCall(dest, headerContent);
        setPlayingStatus({
          playing: true,
          key,
          buttonName,
        });
      }
    } else {
      props.stopCall();
      props.startCall(dest, headerContent);
      setPlayingStatus({
        playing: true,
        key,
        buttonName,
      });
    }
  };

  // const endCall = () => {
  //   props.stopCall();
  // };

  const tableBody = props.callers_in_queues.map((caller, idx) => {
    const key = caller.name + caller.agent + caller.qname;
    const agentSipID = caller.agent_raw;
    const status = caller.status;
    return (
      <tr key={caller.name + caller.agent + caller.qname}>
        <td>{idx + 1}</td>
        <td>{caller.name}</td>
        <td>{caller.agent}</td>
        <td>{caller.qname}</td>
        <td>{caller.status}</td>
        <td>{caller.waiting_time}</td>
        <td>{caller.missed_calls}</td>
        <td>
          <Button
            variant={
              playingStatus.playing &&
              playingStatus.key === key &&
              playingStatus.buttonName === "snoop"
                ? "warning"
                : "primary"
            }
            size="sm"
            onClick={() => testCall(SNOOP_NUMBER, key, "snoop", agentSipID)}
            disabled={
              props.sipConnectionStatus.registered && status === "Talking"
                ? false
                : true
            }
          >
            {playingStatus.playing &&
            playingStatus.key === key &&
            playingStatus.buttonName === "snoop"
              ? "Stop"
              : "Snoop"}
          </Button>
          <Button
            variant={
              playingStatus.playing &&
              playingStatus.key === key &&
              playingStatus.buttonName === "barge"
                ? "warning"
                : "primary"
            }
            size="sm"
            onClick={() => testCall(BARGE_NUMBER, key, "barge", agentSipID)}
            disabled={
              props.sipConnectionStatus.registered && status === "Talking"
                ? false
                : true
            }
          >
            {playingStatus.playing &&
            playingStatus.key === key &&
            playingStatus.buttonName === "barge"
              ? "Stop"
              : "Barge"}
          </Button>
          <Button
            variant={
              playingStatus.playing &&
              playingStatus.key === key &&
              playingStatus.buttonName === "whisper"
                ? "warning"
                : "primary"
            }
            size="sm"
            onClick={() => testCall(WHISPER_NUMBER, key, "whisper", agentSipID)}
            disabled={
              props.sipConnectionStatus.registered && status === "Talking"
                ? false
                : true
            }
          >
            {playingStatus.playing &&
            playingStatus.key === key &&
            playingStatus.buttonName === "whisper"
              ? "Stop"
              : "Whisper"}
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <div>
      <Table striped bordered hover variant="dark">
        <thead>
          <tr>
            <th>#</th>
            <th>Callers</th>
            <th>Agent</th>
            <th>Queue Name</th>
            <th>Status</th>
            <th>Time</th>
            <th>Number of Tries</th>
            <th>Snoop/Barge/Whisper</th>
          </tr>
        </thead>
        <tbody>{tableBody}</tbody>
      </Table>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    callers_in_queues: state.rmqReducer.queues.callers_in_queues,
    user: state.authReducer.user,
    sipConnectionStatus: state.dashboardReducer.sip_connection_status,
  };
};
export default connect(mapStateToProps, {})(Callers);
